import { render } from "./InventoryItemModal.vue?vue&type=template&id=59f49207&scoped=true"
import script from "./InventoryItemModal.vue?vue&type=script&lang=js"
export * from "./InventoryItemModal.vue?vue&type=script&lang=js"

import "./InventoryItemModal.vue?vue&type=style&index=0&id=59f49207&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f49207"]])

export default __exports__